<template>
  <section
    id="section__monthlyearlypaystatistics"
    class="view-container mr-1 ml-1"
    v-if="dailyAmount && salesDailyTotal"
  >
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12" class="mt-5 mb-5">
          <v-card flat>
            <p class="font-size--18 text-center mb-0">{{ yearMonth }} 총 선정산 금액</p>
            <p class="font--m-2 text-center mb-0" v-if="isSameMonth">
              <strong class="font--m-1 money-text-color" data-a45hs67>{{
                dailyAmountTotal | commaFormat
              }}</strong>
              원
            </p>
            <p class="font--m-2 text-center mb-0" v-else>
              <strong class="font--m-1 money-text-color" data-a45hs67>0</strong>
              원
            </p>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-0">
          <v-card flat class="statistics" color="#F4F4F4">
            <v-card-text class="color--black">
              <table class="top-table">
                <tr>
                  <td class="font-size--15">카드/배달 매출액 ({{ dailySalesCount }}건)</td>
                  <td class="text-amount font--m-3" v-if="isSameMonth">
                    {{ dailyTotal | commaFormat }}원
                  </td>
                  <td class="text-amount font--m-3" v-else>0원</td>
                </tr>
                <tr>
                  <td class="font-size--15">카드/배달 수수료</td>
                  <td class="text-amount font--m-3" v-if="isSameMonth">
                    {{ dailyExpectedFee | commaFormat }}원
                  </td>
                  <td class="text-amount font--m-3" v-else>0원</td>
                </tr>
                <tr>
                  <td class="font-size--15">선정산 이자</td>
                  <td class="text-amount font--m-3" v-if="isSameMonth">
                    {{ dailyInterestFee | commaFormat }}원
                  </td>
                  <td class="text-amount font--m-3" v-else>0원</td>
                </tr>
              </table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-sheet height="64">
            <v-toolbar flat class="d-flex justify-center">
              <v-btn fab text small color="grey darken-2" @click="prev" class="text-center">
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar && $refs.calendar.value">
                {{ $moment($refs.calendar.value).format('YYYY년 MM월') }}
              </v-toolbar-title>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="next"
                class="text-center"
                :disabled="isDisabled"
              >
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="530">
            <v-calendar
              ref="calendar"
              v-model="focus"
              :events="events"
              @click:more="viewDay"
              @click:date="goToDay"
              @click:event="showEvent"
              @change="updateRange"
              :event-color="''"
              :event-text-color="(event) => event.textColor"
              :day-header-height="20"
            ></v-calendar>
          </v-sheet>
        </v-col>
        <v-col cols="12">
          <div class="font-size--12">
            <span class="early-text-color" data-c98hs75>■ 선정산금액</span><br />
            <span class="money-text-color" data-a45hs67>■ 매출금액</span><br />
            <span>단위: 원</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dailyAmount: null,
      salesDailyTotal: null,
      year: null,
      month: null,
      selectedDate: null,
      yearMonth: null,
      focus: '',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      eventsTemp: [],
    }
  },
  computed: {
    isSameMonth() {
      const yearAndMonth = this.selectedDate.slice(0, 7)
      const yearMonth1 = this.$moment(yearAndMonth, 'YYYY-MM').format('YYYY-MM')
      const dailyAmount = this.dailyAmount[0].date.slice(0, 7)
      const yearMonth2 = this.$moment(dailyAmount, 'YYYY-MM').format('YYYY-MM')
      return yearMonth1 === yearMonth2
    },
    dailyAmountTotal() {
      const sum = this.dailyAmount.reduce((acc, curr) => acc + curr.amount, 0)
      return sum
    },
    dailyInterestFee() {
      const interest = this.dailyAmount.reduce((acc, curr) => acc + curr.interest, 0)
      const fee = this.dailyAmount.reduce((acc, curr) => acc + curr.fee, 0)
      return interest + fee
    },
    dailyTotal() {
      const sum = this.salesDailyTotal.reduce((acc, curr) => acc + curr.amount, 0)
      return sum
    },
    dailySalesCount() {
      return this.salesDailyTotal ? this.salesDailyTotal.length : 0
    },
    dailyExpectedFee() {
      const sum = this.salesDailyTotal.reduce((acc, curr) => acc + curr.expectedFee, 0)
      return sum
    },
    events() {
      const arr = this.eventsTemp.map((ev) => {
        const textColor = ev.type === 'Sales' ? '#3c73dd' : '#fe8100'
        return {
          name: `${this.changeMoney(ev.amount)}`,
          start: ev.date,
          end: ev.date,
          textColor,
          timed: false,
          origin: ev,
        }
      })
      return arr
    },
    isDisabled() {
      const nextMonth = this.$moment(this.focus).add(1, 'month')
      const today = this.$moment().startOf('month')
      return nextMonth.isAfter(today, 'month')
    },
  },
  async created() {
    const { year, month } = this.getYearAndMonthFromSelectedDate()
    this.year = year
    this.month = month
    this.dailyAmount = await this.getDailyAmount({ year: this.year, month: this.month })
    this.salesDailyTotal = await this.getSalesDailyTotal({ year: this.year, month: this.month })
    this.yearMonth = this.$moment(this.selectedDate, 'YYYY-MM').format('YYYY년 MM월')
    this.focus = this.selectedDate
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.calendar) {
        this.$refs.calendar.checkChange()
      }
    })
  },
  methods: {
    ...mapActions('earlyPayment', ['getDailyAmount', 'getSalesDailyTotal']),
    getYearAndMonthFromSelectedDate() {
      this.selectedDate = this.$route.query.date
      const dateObj = new Date(this.selectedDate)
      const year = dateObj.getFullYear()
      const month = dateObj.getMonth() + 1
      return { year, month }
    },
    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$router.replace({
        path: '/earlypay/statistics/month',
        query: { date: this.convert(this.$moment(this.focus).add(-1, 'month')) },
      })
    },
    next() {
      this.$router.replace({
        path: '/earlypay/statistics/month',
        query: { date: this.convert(this.$moment(this.focus).add(+1, 'month')) },
      })
    },
    convert(date) {
      return date.format('YYYY-MM-DD')
    },
    async getData({ start, end }) {
      const events = this.dailyAmount.map(({ date, amount }) => ({
        date,
        amount,
        type: 'Seonjeongsan',
      }))
      const newEvents = events.concat(
        this.salesDailyTotal.map(({ date, total }) => ({ date, amount: total, type: 'Sales' })),
      )
      this.eventsTemp = newEvents
    },
    showEvent({ nativeEvent, event }) {
      this.$router.push({ name: 'earlypay', query: { date: event.origin.date } })
      nativeEvent.stopPropagation()
    },
    async updateRange({ start, end }) {
      await this.getData({ start: start.date, end: end.date })
    },
    goToDay({ date }) {
      const selectedDate = this.$moment(date)
      const today = this.$moment().startOf('day')
      // 오늘 이후의 날짜인 경우 return
      if (selectedDate.isAfter(today)) {
        return
      }
      this.focus = date
      this.type = 'day'
      this.$router.push({ name: 'earlypay', query: { date: date } })
    },
    changeMoney(won) {
      const arrWon = [
        {
          range: 100000000,
          toFixed: 1,
          text: '억',
        },
        {
          range: 10000,
          toFixed: 0,
          text: '만',
        },
        {
          range: 1,
          toFixed: 0,
          text: '원',
        },
      ]
      const r = [arrWon.find((v) => won >= v.range)].map((v) => {
        if (!v) {
          return ''
        }
        const result = won / v.range
        const fixedNumber = Number(result.toFixed(v.toFixed)).toLocaleString()
        return `${fixedNumber}${v.text}`
      })[0]
      return r
    },
  },
}
</script>
<style lang="scss" scoped>
#section__monthlyearlypaystatistics {
  .v-card {
    width: 100%;
    border-radius: 10px;

    .top-table {
      width: 100%;

      tr {
        td {
          width: 50%;
          padding-bottom: 4px;
          &:first-child {
            width: 50%;
            padding-right: 16px;
          }
        }

        .text-amount {
          text-align: right;
        }
      }
    }
  }
}
.money-text-color[data-a45hs67] {
  color: #3c73dd;
}
.early-text-color[data-c98hs75] {
  color: #fe8100;
}
</style>
